define('directives/bootstrap/ngBsDatepicker',[
	"application",
	"bootstrap",
	"bootstrap-datepicker"
], function (app) {

	return app.directives.directive("ngBsDatepicker", function () {

		return {
			restrict: "A",
			require: "ngModel",
			link: function ($scope, $element, attrs, ngModel) {
				var format = $scope[attrs.ngBsDatepicker] || attrs.ngBsDatepicker || "DD/MM/YYYY";

				$element
					.dtpicker({
						format: format,
						placeholder: $element.attr("placeholder"),
						displayArrow: false,
						closeOnSelect: true,
						clearButtonVisible: false
					})
					.on("dateChanged", onDateChanged);

				$scope.$watch(attrs.ngModel, function (modelValue) {
					$element.dtpicker("setDate", modelValue, true);
				});

				$scope.$on("$destroy", function () {
					$element.off("dateChanged", onDateChanged);
				});

				function onDateChanged(e, d) {
					$scope.$apply(function () {
						ngModel.$setViewValue(d);
					});
				}
			}
		};

	});

});
